import React, { Component } from "react";
import "./PharmacyEntryMaster.css";

import Moment from "react-moment";
import Paper from "@material-ui/core/Paper";
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import "./PrescriptionItem.css";
import dateFormat from 'dateformat';


class Prescriptionsave extends Component {
  constructor(props) {
    super(props);
    this.state = {
      totalAmount:0,
      prescriptionEntryData: [],
      open: false,
    };
  }
  open = () => {
    this.setState({ open: true });
  };

  componentDidMount() {
    // console.log(this.props, "prescriptionEntryData")
    var totalAmount=0;
    this.setState({
      prescriptionEntryData: this.props.prescriptionEntryData
    })

      this.props.prescriptionEntryData[0].medicines.map((val)=>{
        return(
          totalAmount=totalAmount+Number(val.amount)
        )
      })
    
      this.setState({totalAmount:totalAmount})

    this.setState({})
  }

  render() {
    const { prescriptionEntryData } = this.props;
    return (
      <div className="pharmacy_pres_master">
        <Paper>
          <div className="presborder_box">
            <div className="master_head">
              {/* <p className="pres_entry"><span><ArrowBackIosIcon className="backArrowIcon" onClick={this.props.getBackView} /></span><span>PRESCRIPTION PROCESS</span></p> */}
            </div>
            {/* <div className="master_headdetails">
              <div>
                <p className="mastertotay_date">Member Name</p>
                <label className="pres_time">{prescriptionEntryData[0].patient_name}</label>
              </div>
              <div>
                <p className="mastertotay_date">Doctor</p>
                <label className="pres_time">{prescriptionEntryData[0].doctor_name}</label>
              </div>
              <div className="pres_time">
                <p className="mastertotay_date">Date</p>
                {dateFormat(prescriptionEntryData[0].prescript_date, "dd-mmm-yy")}
              </div>
            </div> */}
          </div>
        </Paper>
        <div className="">
          {
            prescriptionEntryData[0].medicines.map((val) => {
              return (
                <div className="card viewCardBoxShadow">
                  <div className="card-body viewCardBoxPad">
                    <div className="d-flex">
                      <div className="largeBoxSpace">
                        <div className="cardInputName">Medicine Name</div>
                        <input className="cardInputValue" value={val.medicine} />
                      </div>
                      <div className="largeBoxSpace">
                        <div className="cardInputName">Unit Rate</div>
                        <input className="cardInputValue unitRateWidth" value={val.unit_rate} />
                      </div>
                      <div className="largeBoxSpace">
                        <div className="cardInputName">Quantity</div>
                        <input className="cardInputValue unitRateWidth" value={val.quantity} />
                      </div>
                      <div className="largeBoxSpace">
                        <div className="cardInputName">Amount</div>
                        <input className="cardInputValue unitRateWidth" value={val.amount} />
                      </div>
                      <div className="littleBoxSpace">
                        <div className="cardInputName labelCenterText">Day</div>
                        <input className="cardInputValue littleBoxWidth" value={val.day} />
                      </div>
                      <div className="littleBoxSpace">
                        <div className="cardInputName labelCenterText">M</div>
                        <input className="cardInputValue littleBoxWidth" value={val.morning} />
                      </div>
                      <div className="littleBoxSpace">
                        <div className="cardInputName labelCenterText">A</div>
                        <input className="cardInputValue littleBoxWidth" value={val.afternoon} />
                      </div>
                      <div className="littleBoxSpace">
                        <div className="cardInputName labelCenterText">N</div>
                        <input className="cardInputValue littleBoxWidth" value={val.night} />
                      </div>
                    </div>
                    <div className="mt-4">
                      <div className="cardInputName">Instrcution</div>
                      <input className="instructionInput" value={val.instruction} />
                    </div>
                  </div>
                </div>
              )
            })
          }
          <div className="totalAmountPrescription"><span className="mr-3">Total Amount</span><input className="totalAmountInput" value={this.state.totalAmount} /></div>
        </div>
      </div>
    );
  }
}
export default Prescriptionsave;
